import {
  getFeaturedPosts,
  type BlogPost,
} from "@/data/blogData";
import type { SiteLanguageCode } from "@/lib/language";

type FeaturedOverlay = {
  title: string;
  excerpt: string;
  category: string;
};

/** Hindi overlays for Home featured posts, keyed by slug. */
const featuredHi: Record<string, FeaturedOverlay> = {
  "future-of-web-development-2026": {
    title: "2026 में वेब डेवलपमेंट का भविष्य",
    excerpt:
      "AI-सहायक कोडिंग से लेकर क्रांतिकारी फ्रेमवर्क तक - वे तकनीकें जो डिजिटल अनुभव बनाने के तरीके बदल रही हैं।",
    category: "तकनीक",
  },
  "building-scalable-apis-best-practices": {
    title: "स्केलेबल API बनाना: 2026 के लिए सर्वोत्तम अभ्यास",
    excerpt:
      "परफ़ॉर्मेंस और विश्वसनीयता बनाए रखते हुए लाखों अनुरोध संभाल सकने वाले API डिज़ाइन और इम्प्लीमेंट करने की ज़रूरी रणनीतियाँ सीखें।",
    category: "डेवलपमेंट",
  },
  "mastering-typescript-advanced-patterns": {
    title: "TypeScript में महारत: उन्नत पैटर्न और तकनीकें",
    excerpt:
      "TypeScript की शक्तिशाली टाइप सिस्टम में गहराई से जाएँ - ऐसे उन्नत पैटर्न जो कोड गुणवत्ता और डेवलपर अनुभव बढ़ाएँ।",
    category: "डेवलपमेंट",
  },
};

function applyOverlay(post: BlogPost, overlay?: FeaturedOverlay): BlogPost {
  if (!overlay) return post;
  return {
    ...post,
    title: overlay.title,
    excerpt: overlay.excerpt,
    category: overlay.category,
  };
}

export function localizeFeaturedPosts(
  count: number = 3,
  lang: SiteLanguageCode,
): BlogPost[] {
  const posts = getFeaturedPosts(count);
  if (lang !== "hi") return posts;
  return posts.map((post) => applyOverlay(post, featuredHi[post.slug]));
}
